import { Claim } from 'src/services/generated/api.generated.v1';

export default class ClaimHelper {
    static GetClaims(claims: Array<Claim> | null | undefined, claimType: string): Array<Claim> {
        return claims?.filter(x => x.type == claimType) ?? [];
    }

    static GetClaimValue(claims: Array<Claim> | null | undefined, claimType: string): string | null {
        return claims?.find(x => x.type == claimType)
            ?.value ?? null;
    }

    static GetClaimValues(claims: Array<Claim> | null | undefined, claimType: string): Array<string> {
        return claims?.filter(x => x.type == claimType)
            ?.map(x => x.value ?? '') ?? []
    }
}